import styled from "styled-components";

export const PrincipalTemplateContainer = styled.div`

`